/* eslint-disable no-control-regex */
import React, { useRef, useState } from 'react';
import styles from './styles.module.scss';
import { Body, Heading, Button } from '../UI';
import Row from '../Row';
import LoadingButton from '../loading-button';
import { ScannerError } from './types';

interface ManualBarcodeEntryProps {
    onSearch: (barcode: Pick<DetectedBarcode, 'format' | 'rawValue'>) => void;
    onClose: () => void;
    // scannerError: ScannerError;
    scannerError?: string;
    setScannerError: React.Dispatch<React.SetStateAction<ScannerError>>;
    setIsInfoDrawerOpen: (flag: boolean) => void;
    isInfoDrawerOpen: boolean;
}

function ManualBarcodeEntry({
    onSearch,
    onClose,
    scannerError,
    setScannerError,
    setIsInfoDrawerOpen,
    isInfoDrawerOpen,
}: ManualBarcodeEntryProps) {
    const [barcode, setBarcode] = useState('');
    const inputRef = useRef<any>(null);

    const validateBarcode = (code: string) => {
        if (code.length !== 12) {
            if (code.length === 0) {
                setScannerError({
                    body: 'Barcode is required field.',
                });
            } else {
                setScannerError({
                    body: 'Barcode should be of 12 numeric digits.',
                });
            }

            return false;
        }
        return true;
    };

    const handleOnBlur = () => {
        if (isInfoDrawerOpen) return;
        validateBarcode(barcode);
    };

    const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log('on Submit');
        if (validateBarcode(barcode)) {
            onSearch({
                rawValue: barcode,
                format: 'upc_a',
            });
        }
    };

    // const errorState =
    //     scannerError.description.length > 0 &&
    //     !scannerError?.title?.includes?.('Scan successful');

    return (
        <div className={styles.manualBarcodeContainer}>
            <Heading type="h3" size={20} lineHeight={26} weight="bold">
                Enter product barcode manually
            </Heading>
            <form
                id="otpForm"
                onSubmit={handleOnSubmit}
                className={styles.form}
            >
                <Row direction="column" gap="5px" className={styles.my}>
                    <>
                        <input
                            className={`${styles.input} ${
                                scannerError ? styles.inputError : null
                            }`}
                            type="text"
                            onChange={(e) => {
                                if (/^[0-9]*$/.test(e.target.value)) {
                                    setBarcode(e.target.value);
                                    setScannerError(null);
                                }
                            }}
                            onClick={() => {
                                setIsInfoDrawerOpen(false);
                                setTimeout(() => {
                                    inputRef?.current?.focus?.();
                                }, 300);
                            }}
                            onBlur={handleOnBlur}
                            id="barcodeInput"
                            name="barcodeInput"
                            inputMode="numeric"
                            maxLength={18}
                            value={barcode}
                            ref={inputRef}
                        />
                        {scannerError && (
                            <Body
                                className={styles.errorText}
                                size={12}
                                weight="light"
                                lineHeight={16}
                            >
                                {scannerError}
                            </Body>
                        )}
                    </>
                </Row>
                <div className={styles.buttonContainer}>
                    <LoadingButton
                        className={styles.saveButton}
                        style={{
                            background:
                                barcode?.length !== 12 || Boolean(scannerError)
                                    ? '#D3D3D3'
                                    : '#cc0000',
                        }}
                        disabled={
                            barcode?.length !== 12 || Boolean(scannerError)
                        }
                        type="submit"
                    >
                        Search
                    </LoadingButton>
                    <Button
                        variant="text"
                        color="textLinkBlue"
                        className={styles.cancelButton}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                </div>
            </form>
        </div>
    );
}

export default ManualBarcodeEntry;
